import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import {
  createInvestorCheckSuccess,
  deleteInvestorCheckSuccess,
  fetchAvailableChecksBegin,
  fetchAvailableChecksFailure,
  fetchAvailableChecksSuccess,
  fetchInvestorChecksBegin,
  fetchInvestorChecksFailure,
  fetchInvestorChecksSuccess,
  InvestorCheckAction,
  updateInvestorCheckSuccess,
} from './actions'
import { InvestorChecksState } from './types'

export const investorChecksReducer = combineReducers<InvestorChecksState, InvestorCheckAction>({
  isFetching: (isFetching = false, action) => {
    switch (action.type) {
      case getType(fetchInvestorChecksBegin):
        return true
      case getType(fetchInvestorChecksSuccess):
      case getType(fetchInvestorChecksFailure):
        return false
      default:
        return isFetching
    }
  },
  items: (investorChecks = {}, action) => {
    switch (action.type) {
      case getType(fetchInvestorChecksBegin):
        return {}
      case getType(fetchInvestorChecksSuccess):
        return action.payload.investorChecks
      case getType(createInvestorCheckSuccess):
      case getType(updateInvestorCheckSuccess): {
        const { investorCheck } = action.payload
        return {
          ...investorChecks,
          [investorCheck.id]: investorCheck,
        }
      }
      case getType(deleteInvestorCheckSuccess): {
        const { investorCheckId } = action.payload
        const nextState = { ...investorChecks }
        delete nextState[investorCheckId]
        return nextState
      }
      default:
        return investorChecks
    }
  },
  availableChecks: (availableChecks = [], action) => {
    switch (action.type) {
      case getType(fetchAvailableChecksBegin):
        return []
      case getType(fetchAvailableChecksSuccess):
        return action.payload.availableChecks
      default:
        return availableChecks
    }
  },
  isFetchingAvailableChecks: (isFetching = false, action) => {
    switch (action.type) {
      case getType(fetchAvailableChecksBegin):
        return true
      case getType(fetchAvailableChecksSuccess):
      case getType(fetchAvailableChecksFailure):
        return false
      default:
        return isFetching
    }
  },
})
